__turbopack_context__.v({
  "cardNew": "Comparison-module__Vt2b4W__cardNew",
  "cardOld": "Comparison-module__Vt2b4W__cardOld",
  "container": "Comparison-module__Vt2b4W__container",
  "grid": "Comparison-module__Vt2b4W__grid",
  "header": "Comparison-module__Vt2b4W__header",
  "itemNew": "Comparison-module__Vt2b4W__itemNew",
  "itemOld": "Comparison-module__Vt2b4W__itemOld",
  "listNew": "Comparison-module__Vt2b4W__listNew",
  "listOld": "Comparison-module__Vt2b4W__listOld",
  "newSubtitle": "Comparison-module__Vt2b4W__newSubtitle",
  "oldSubtitle": "Comparison-module__Vt2b4W__oldSubtitle",
  "popularBadge": "Comparison-module__Vt2b4W__popularBadge",
  "section": "Comparison-module__Vt2b4W__section",
  "vsBadge": "Comparison-module__Vt2b4W__vsBadge",
});
